<div
  class="usf-pme-product-card"
  [class.selected-card]="false"
  (click)="onProductClick()"
  data-cy="pme-product-card-desktop"
>
  <div
    class="pme-card-content flex column"
    [class.has-warning-drawer]="product?.drawerMsg?.isWarning"
  >
    <div *ngIf="product?.drawerMsg">
      <app-product-card-drawer
        [drawerMessage]="product?.drawerMsg"
        [warningMessage]="product?.productCardWarningMsg"
      >
      </app-product-card-drawer>
    </div>

    <div class="pme-card-content-container">
      <div class="product-info-container" data-cy="pme-product-info-container">
        <div class="product-image">
          <app-product-card-image
            [isOnline]="isOnline"
            [imageThumbnail]="product?.imageThumbnail"
            [productNumber]="product?.productNumber"
            [clickable]="false"
            [isMedium]="screenWidth < 1200"
          ></app-product-card-image>
        </div>

        <div class="pme-container">
          <div class="product-details" data-cy="pme-product-details">
            <app-product-card-information
              [brand]="product?.summary?.brand"
              [description]="product?.summary?.productDescTxtl"
              [note]="product?.item?.note"
              [productNumber]="product?.productNumber"
              [salesPackSize]="product?.summary?.salesPackSize"
              [showNote]="true"
              [notFound]="false"
              [customerProductNumber]="product?.customerProductNumber"
              [showPowerReview]="false"
              [pricePerPortion]="product?.pricePerPortion"
              [clickable]="false"
              [isGuestUser]="false"
              (itemNoteClickEmitter)="itemNoteClicked()"
            >
            </app-product-card-information>
          </div>
          <ng-container *ngIf="screenWidth >= 1200">
            <ng-container *ngTemplateOutlet="pmeInfoWide"></ng-container>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="screenWidth < 1200">
        <ng-container *ngTemplateOutlet="pmeInfoNarrow"></ng-container>
      </ng-container>
      <!-- right column -->
      <div class="pricing-info" data-cy="pme-pricing-info">
        <div class="current-week-wrapper" data-cy="pme-current-week">
          <div class="value">
            {{ 'i18n.lists.pmeList.currentWeek' | translate }}
          </div>
          <div class="calculations-container">
            <div class="value">
              {{
                product?.easyPricingViewModel?.currentPrice?.unitPrice
                  ? (product?.easyPricingViewModel?.currentPrice?.unitPrice
                    | currency)
                  : 'N/A'
              }}
            </div>
            <div
              *ngIf="product?.easyPricingViewModel?.currentWeekDifference"
              class="price-change-value"
              [class.negative]="
                product?.easyPricingViewModel?.currentWeekDifference < 0
              "
              data-cy="pme-price-change"
            >
              <span>
                {{
                  product?.easyPricingViewModel?.currentWeekDifference
                    | currency
                }}
              </span>
              <img
                *ngIf="product?.easyPricingViewModel?.currentWeekDifference"
                [src]="
                  product?.easyPricingViewModel?.currentWeekDifference > 0
                    ? 'assets/icon/up-arrow.svg'
                    : 'assets/icon/down-arrow.svg'
                "
                [alt]="
                  product?.easyPricingViewModel?.currentWeekDifference > 0
                    ? 'arrow-up'
                    : 'arrow-down'
                "
              />
            </div>
          </div>
        </div>

        <div
          class="target-case-price-wrapper"
          data-cy="pme-target-case-price-wrapper"
        >
          <div class="value">
            {{ 'i18n.lists.pmeList.targetCasePrice' | translate }}
          </div>
          <div
            class="target-case-price-container"
            [class.selected]="false"
            (click)="selectTargetPrice()"
            data-cy="pme-target-case-price-container"
          >
            <img
              *ngIf="false"
              src="assets/icon/checkmark-fill-green.svg"
              alt="checkmark"
              class="checkmark-icon"
            />
            <div
              class="target-case-price"
              [class.selected]="false"
              data-cy="pme-target-case-price"
            >
              {{
                product?.easyPricingViewModel?.targetCasePrice
                  ? (product?.easyPricingViewModel?.targetCasePrice | currency)
                  : 'N/A'
              }}
            </div>
          </div>
        </div>
        <div>
          <div
            class="custom-case-price-wrapper"
            data-cy="pme-custom-case-price-wrapper"
          >
            <div class="value">
              {{ 'i18n.lists.pmeList.customCasePrice' | translate }}
            </div>
            <div class="price-change-container-wrapper">
              <ion-input
                id="cs-{{ product?.listId }}-{{ index }}"
                globalkeyhandler="quantityInput"
                [class.accepted]="false"
                [class.denied]="false"
                mode="md"
                fill="outline"
                type="number"
                placeholder="$0.00"
                data-cy="pme-custom-price-input"
                (ionBlur)="onCustomPriceChange($event)"
              ></ion-input>
            </div>
          </div>
          <div
            class="price-change-status-wrapper"
            data-cy="pme-price-change-status-wrapper"
          >
            <div class="placeholder"></div>
            <div
              *ngIf="false"
              class="price-change-status"
              [class.accepted]="false"
              [class.denied]="false"
              data-cy="pme-price-change-status"
            >
              <img
                *ngIf="false"
                src="assets/icon/checkmark-fill-green.svg"
                alt="checkmark"
                class="checkmark-icon"
              />
              <img
                *ngIf="false"
                src="assets/icon/info.svg"
                alt="info"
                class="info-icon"
                (click)="openPopover($event)"
              />
              <!-- {{ priceChangeStatus | uppercase }} -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ion-popover
  class="pme-price-change-status-popover"
  #popover
  mode="ios"
  arrow="true"
  side="bottom"
  alignment="center"
  [isOpen]="isPopoverOpen"
  data-cy="pme-price-change-popover"
  (didDismiss)="isPopoverOpen = false"
>
  <ng-template>
    <ion-content class="ion-padding">
      <p data-cy="pme-price-change-popover-message">
        This price change was denied because it falls below the minimum
        allowable price for this product.
      </p>
    </ion-content>
  </ng-template>
</ion-popover>

<ng-template #pmeInfoWide>
  <div class="pme-info-prices" data-cy="pme-info-prices">
    <div class="info-item" data-cy="pme-last-week">
      <span class="label"
        >{{ 'i18n.lists.pmeList.lastWeek' | translate }}&nbsp;</span
      >
      <span class="value">{{
        product?.easyPricingViewModel?.lastPrice?.unitPrice
          ? (product?.easyPricingViewModel?.lastPrice?.unitPrice | currency)
          : 'N/A'
      }}</span>
    </div>
    <div class="info-item" data-cy="pme-low-limit">
      <span class="label"
        >{{ 'i18n.lists.pmeList.lowLimit' | translate }}&nbsp;</span
      >
      <span class="value">{{
        product?.easyPricingViewModel?.lowLimit
          ? (product?.easyPricingViewModel?.lowLimit | currency)
          : 'N/A'
      }}</span>
    </div>
  </div>
  <div class="pme-info-additional" data-cy="pme-info-additional">
    <div class="info-item" data-cy="pme-wwp">
      <span class="label"
        >{{ 'i18n.lists.pmeList.wwp' | translate }}&nbsp;</span
      >
      <span class="value">{{
        product?.easyPricingViewModel?.wwp || 'N/A'
      }}</span>
    </div>
    <div class="info-item rationale" data-cy="pme-rationale">
      <span class="label"
        >{{ 'i18n.lists.pmeList.rationale' | translate }}&nbsp;</span
      >
      <span class="value">{{
        product?.easyPricingViewModel?.rationale || 'N/A'
      }}</span>
    </div>
    <div class="info-item target-difference" data-cy="pme-target-difference">
      <span class="label"
        >{{ 'i18n.lists.pmeList.targetDifference' | translate }}&nbsp;</span
      >
      <span class="value">{{
        product?.easyPricingViewModel?.targetDifference
          ? (product?.easyPricingViewModel?.targetDifference | currency)
          : 'N/A'
      }}</span>
    </div>
  </div>
</ng-template>

<ng-template #pmeInfoNarrow>
  <div class="pme-info-container" data-cy="pme-touch-info-container">
    <div class="pme-info-column" data-cy="pme-touch-info-column-1">
      <div class="info-item" data-cy="pme-touch-last-week">
        <span class="label"
          >{{ 'i18n.lists.pmeList.lastWeek' | translate }}&nbsp;</span
        >
        <span class="value">{{
          product?.easyPricingViewModel?.lastPrice?.unitPrice
            ? (product?.easyPricingViewModel?.lastPrice?.unitPrice | currency)
            : 'N/A'
        }}</span>
      </div>
      <div class="info-item" data-cy="pme-touch-low-limit">
        <span class="label"
          >{{ 'i18n.lists.pmeList.lowLimit' | translate }}&nbsp;</span
        >
        <span class="value">{{
          product?.easyPricingViewModel?.lowLimit
            ? (product?.easyPricingViewModel?.lowLimit | currency)
            : 'N/A'
        }}</span>
      </div>
    </div>
    <div class="pme-info-column" data-cy="pme-touch-info-column-2">
      <div class="info-item" data-cy="pme-touch-wwp">
        <span class="label"
          >{{ 'i18n.lists.pmeList.wwp' | translate }}&nbsp;</span
        >
        <span class="value">{{
          product?.easyPricingViewModel?.wwp || 'N/A'
        }}</span>
      </div>
      <div class="info-item" data-cy="pme-touch-rationale">
        <span class="label"
          >{{ 'i18n.lists.pmeList.rationale' | translate }}&nbsp;</span
        >
        <span class="value">{{
          product?.easyPricingViewModel?.rationale || 'N/A'
        }}</span>
      </div>
    </div>
    <div class="pme-info-column" data-cy="pme-touch-info-column-3">
      <div class="info-item" data-cy="pme-touch-target-difference">
        <span class="label"
          >{{ 'i18n.lists.pmeList.targetDifference' | translate }}&nbsp;</span
        >
        <span class="value">{{
          product?.easyPricingViewModel?.targetDifference
            ? (product?.easyPricingViewModel?.targetDifference | currency)
            : 'N/A'
        }}</span>
      </div>
      <div class="info-item"></div>
    </div>
  </div>
</ng-template>
